type Props = {
  label: string;
  count?: number;
  accent?: string;
  animate?: boolean;
};

export function SectionHeader({ label, count, accent = '#7a8595', animate }: Props) {
  return (
    <div className="flex items-center gap-2 px-4 mb-2 mt-6">
      {animate && (
        <span
          className="w-1.5 h-1.5 rounded-full anim-blink shrink-0"
          style={{ background: accent, boxShadow: `0 0 8px ${accent}` }}
        />
      )}
      <h2 className="font-display font-semibold text-[13px] tracking-[0.08em] text-fg uppercase">
        {label}
      </h2>
      {typeof count === 'number' && (
        <span className="font-mono text-[11px] text-fg-dim">{count}</span>
      )}
    </div>
  );
}
